import { getCycles } from './GetCycles';
import { getCycleById } from './GetCycleById';
import { createCycle } from './CreateCycle';
import { updateCycle } from './UpdateCycle';
import { getCycleMemberships } from './GetCycleMemberships';
import { getMemberApplication } from './GetMemberApplication';
import { getMemberReceivedFeedback } from './GetMemberReceivedFeedback';
import { getUserCycles } from './GetUserCycles';
import { updateMembershipStatus } from './UpdateMembershipStatus';
import { uploadMembershipsCsv } from './UploadMembershipsCsv';
import { downloadCycleExport } from './DownloadCycleExport';

export const AwardsService = {
  getCycles,
  getCycleById,
  createCycle,
  updateCycle,
  getCycleMemberships,
  getMemberApplication,
  getMemberReceivedFeedback,
  getUserCycles,
  updateMembershipStatus,
  uploadMembershipsCsv,
  downloadCycleExport,
};
